import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className="pt-4 px-4">
      {/* Mobile Navbar */}
      <div className="md:hidden">
        <div className="flex items-center justify-between px-2 py-2">
          {/* Logo - Left aligned, big and bold */}
          <h1 className="text-3xl font-extrabold text-brand-500" style={{ fontFamily: 'Poppins, sans-serif' }}>
            .decimal
          </h1>

          {/* Mobile menu button - Rounded with brand color */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="w-12 h-12 rounded-full bg-brand-500 flex items-center justify-center hover:bg-brand-600 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="h-6 w-6 text-white" />
            ) : (
              <Menu className="h-6 w-6 text-white" />
            )}
          </button>
        </div>

        {/* Mobile menu dropdown */}
        {isMobileMenuOpen && (
          <div className="bg-white rounded-2xl shadow-lg mt-2 mx-2">
            <div className="px-4 py-4 space-y-2">
              <button
                onClick={() => scrollToSection('why-us')}
                className="block w-full text-left py-3 text-gray-700 hover:text-brand-500 transition-colors font-medium"
              >
                Why us
              </button>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="block w-full text-left py-3 text-gray-700 hover:text-brand-500 transition-colors font-medium"
              >
                How it works
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="block w-full text-left py-3 text-gray-700 hover:text-brand-500 transition-colors font-medium"
              >
                Testimonials
              </button>
              <button
                onClick={() => scrollToSection('faqs')}
                className="block w-full text-left py-3 text-gray-700 hover:text-brand-500 transition-colors font-medium"
              >
                FAQs
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Desktop Navbar */}
      <div className="hidden md:block">
        <div className="max-w-3xl mx-auto">
          <div
            className={`bg-white/95 backdrop-blur-sm rounded-full shadow-lg border border-gray-200 px-6 transition-all duration-300 ${
              isScrolled ? 'shadow-xl' : 'shadow-lg'
            }`}
          >
            <div className="flex items-center justify-center h-14 gap-8">
              {/* Left Nav Items */}
              <div className="flex items-center gap-8">
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="text-gray-800 hover:text-brand-500 transition-colors duration-200 font-medium text-lg"
                >
                  Why us
                </button>
                <button
                  onClick={() => scrollToSection('how-it-works')}
                  className="text-gray-800 hover:text-brand-500 transition-colors duration-200 font-medium text-lg"
                >
                  How it works
                </button>
              </div>

              {/* Logo - Centered */}
              <div className="flex-shrink-0">
                <h1 className="text-2xl font-bold text-brand-500" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  .decimal
                </h1>
              </div>

              {/* Right Nav Items */}
              <div className="flex items-center gap-8">
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-800 hover:text-brand-500 transition-colors duration-200 font-medium text-lg"
                >
                  Testimonials
                </button>
                <button
                  onClick={() => scrollToSection('faqs')}
                  className="text-gray-800 hover:text-brand-500 transition-colors duration-200 font-medium text-lg"
                >
                  FAQs
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;